import api from '@/utils/api';

const { baseApi } = window.GlobalConfig;

// =============================
// 岗位模块

export const getPost = data => {
    return api.post(`${baseApi}/post/getPostList`, data);
};

export const savePost = data => {
    return api.post(`${baseApi}/post/addPost`, data);
};

export const updatePost = data => {
    return api.post(`${baseApi}/post/updatePost`, data);
};

export const deletePost = data => {
    return api.get(`${baseApi}/post/deletePost/${data.postId}`);
};

// ==============================
// 部门模块

export const getDept = () => {
    return api.get(`${baseApi}/dept/getDeptTree`);
};

export const saveDept = data => {
    return api.post(`${baseApi}/dept/addDept`, data);
};

export const updateDept = data => {
    return api.post(`${baseApi}/dept/updateDept`, data);
};

export const deleteDept = data => {
    return api.get(`${baseApi}/dept/deleteDept/${data.deptId}`);
};

// 销售人员盘点

export const QuerySaleUser = data => {
    return api.post(`${baseApi}/userInventory/getUserInventoryByArea`, data);
};

export const QueryAssginRegionList = data => {
    return api.get(`${baseApi}/userInventory/getRegionNoneControl`, { params: data });
};

export const QueryAssginRegionCustomer = data => {
    return api.post(`${baseApi}/userInventory/getCustomerNoneControl`, data);
};

export const SaveAssginRegion = () => {
    return api.get(`${baseApi}`);
};

export const SaveAssginRegionCustomer = data => {
    return api.post(`${baseApi}/userInventory/addCustomerControlUser`, data);
};

export const QueryCustomerByUser = data => {
    return api.get(`${baseApi}/userInventory/getCustomerMaintainByUserId/${data.userId}`);
};

// 新人员盘点

export const QueryAreaAssgin = data => {
    return api.post(`${baseApi}/userInventory/getAreaInventoryByParent`, data);
};

export const QueryAreaCustomer = data => {
    return api.post(`${baseApi}/customer/getCustomerStoreByAreaId`, data);
};

export const QueryAreaRegion = data => {
    return api.post(`${baseApi}/areaRegion/getRegionListByArea`, data);
};

export const QueryIncomeDataAuthority = data => {
    return api.get(`${baseApi}/component/getComponentIncomeDataAuthority`);
};

export const QueryControlTypeCode = () => {
    return api.get(`${baseApi}/component/getComponentControlTypeCodeSale`);
};

export const SaveCustomerControlUser = data => {
    return api.post(`${baseApi}/dataAuthority/saveCustomerControlUser`, data);
};

// 区域负责人
export const QueryControlUserList = data => {
    return api.post(`${baseApi}/component/getComponentControlUserListRecursive`, data);
};

// 递归查询区域负责人
export const QueryControlUserAllList = data => {
    return api.post(`${baseApi}/component/getComponentControlUserList`, data);
};

export const QueryRegionTypeCode = () => {
    return api.get(`${baseApi}/component/getComponentControlTypeCodeDevelop`);
};

export const GetRegionControl = data => {
    return api.post(`${baseApi}/areaRegion/getRegionControlByRegion`, data);
};

// 人员盘点改动
export const QueryUserInventory = data => {
    return api.post(`/userInventory/getAreaInventoryByParent`, data);
};

export const QueryCustomerByAreaUser = data => {
    return api.post(`/userInventory/getCustomer4UserInventoryPage`, data);
};

//重新分配
export const SaveAssginCustomer = data => {
    return api.post(`/dataAuthority/saveCustomerControlUser`, data);
};

// 人员盘点区域
export const QueryUserInventogyArea = data => {
    return api.post(`/userInventory/getAreaInventoryByParentWithAuthority`, data);
};

export const RemoveUserInventogy = data => {
    return api.post(`/dataAuthority/removeCustomerControlUser`, data);
};

//
